import { normalizeAppLocalUrlPath, toAppLocalUrlPath } from "./public-path";

const DEFAULT_REDIRECT_FALLBACK = "/dashboard";
const LOCAL_REDIRECT_BASE_URL = "http://admin.local";

function parseSafeRelativeRedirect(value: string) {
  if (!value.startsWith("/") || value.startsWith("//")) {
    return null;
  }
  try {
    const parsed = new URL(value, LOCAL_REDIRECT_BASE_URL);
    return {
      pathname: parsed.pathname || "/",
      suffix: `${parsed.search}${parsed.hash}`,
    };
  } catch {
    return null;
  }
}

function formatRedirectPath(pathname: string, suffix: string) {
  const normalizedPathname = pathname.startsWith("/") ? pathname : `/${pathname}`;
  return `${normalizedPathname || "/"}${suffix}`;
}

function normalizeRedirectPath(path: string) {
  try {
    return normalizeAppLocalUrlPath(toAppLocalUrlPath(path));
  } catch {
    return normalizeAppLocalUrlPath(path);
  }
}

function normalizeFallbackPath(fallback: string) {
  const parsedFallback = parseSafeRelativeRedirect(
    String(fallback || DEFAULT_REDIRECT_FALLBACK).trim(),
  );
  return parsedFallback
    ? normalizeRedirectPath(formatRedirectPath(parsedFallback.pathname, parsedFallback.suffix))
    : DEFAULT_REDIRECT_FALLBACK;
}

export function sanitizeRedirectPath(rawValue: string | null | undefined, fallback = "/dashboard") {
  const fallbackPath = normalizeFallbackPath(fallback);
  const value = String(rawValue || "").trim();
  if (!value) return fallbackPath;

  const parsedValue = parseSafeRelativeRedirect(value);
  if (!parsedValue) return fallbackPath;

  return normalizeRedirectPath(formatRedirectPath(parsedValue.pathname, parsedValue.suffix));
}
